import React from "react";
import { ClassesDataTable } from "./";

const ClassesPage = () => {
  return (
    <div className="sub-content">
      <ClassesDataTable />
    </div>
  );
};

export default ClassesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/ClassesPage.js